
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(2(13|2|3)|[03]88|139|154|374|641|819)|2(036|110|244|280|333|446|658)|5(7(14|36|76)|9(07|18|47)|(14|22|56)8)|6([78]57|309|382|418|936)|1((50|58|84)2|233|264|424|471|696|839|923|960)|8(007|065|334|452|486|98)|7(017|030|187|332|340|681|911|936)|3(9(36|75|94)|266|405|467|589|785)|9(8(08|15|61|83)|288|431|475|554|724|993))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
